export const CCIS_IMAGE_BASE_URL = 'https://kong-proxy-aws.toyota-europe.com';

export const CAR_ASSETS_IMAGE_BASE_URL = 'https://l1-carassets.lexus-europe.com';

export const BREAKPOINT_DEFINITIONS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
  xxxl: 1920
};

export const MEDIA_TYPES = {
  image: 'image',
  video: 'video'
};